export const FETCH_DATA_NOTA_CREDITO = 'casos/FETCH_DATA_NOTA_CREDITO';
export const GET_DATA_ROWS_NOTA_CREDITO = 'casos/GET_DATA_ROWS_NOTA_CREDITO';
export const SET_DATA_ROWS_NOTA_CREDITO = 'casos/SET_DATA_ROWS_NOTA_CREDITO';
